<template>
  <div v-if="title">
    <b-input-group size="sm">
      <template v-slot:prepend>
        <b-input-group-text>
          <span class="d-inline d-md-none">Подразделение</span><span class="d-none d-md-inline">Подразделение</span>
        </b-input-group-text>
      </template>
      <b-form-select v-if="register.options.length > 0" :options="register.options" :value="value" v-model="model"
                     @change="Select()"></b-form-select>
      <b-form-input readonly v-else size="sm" value="Справочник подразделений не заполнен"></b-form-input>
    </b-input-group>
  </div>
  <div v-else>
    <b-form-select size="sm" v-if="register.options.length > 0" :options="register.options" :value="value" v-model="model"
                   @change="Select()"></b-form-select>
    <b-form-input readonly v-else size="sm" value="Справочник подразделений не заполнен"></b-form-input>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SelectGroups',
  props: ['title', 'value'],

  methods: {
    Select: function () {
      if (this.org) {
        this.$http
            .post(this.$apiold, {
              task: 'list',
              mode: 'group',
              id: this.register.current,
              orgid: this.orgs.current.id,
              params: {name: 'groups', table: 'reg_groups', order: ' ORDER BY name ASC'},
              changed: true
            })
            .then(response => {
              response
              this.$store.commit('regChange', {name: 'groups', register: response.data.register});
            });
      } else {
        this.$http
            .post(this.$apiold, {
              task: 'list',
              mode: 'group',
              id: this.register.current,
              orgid: this.orgs.current.id,
              params: {name: 'groups', table: 'reg_groups', org: true, order: ' ORDER BY name ASC'},
              changed: true
            })
            .then(response => {
              response
              this.$store.commit('regChange', {name: 'groups', register: response.data.register});
            });
      }


    }
  },

  created() {
    this.Select()
  },

  computed: {
    ...mapGetters({
      orgs: 'orgs',
      changed: 'changed'
    }),
    register: {
      get() {
        return this.$store.getters.regSelect('groups', ['name'], true);
      }
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    changed() {
      this.Select();
    },
    orgs() {
      this.Select();
    }
  }
}
</script>
